import {useCallback, useRef} from 'react';

export const useTranscriptions = ({
                                      transcriptions, setTranscriptions,
                                      participants, userId, settings,
                                      addTranscriptionToStore
                                  }) => {
    const processedTranscriptionsRef = useRef(new Set());

    const handleTranscription = useCallback((msg) => {
        const uniqueId = `${msg.userId}-${msg.timestamp}-${msg.transcript}`;

        if (processedTranscriptionsRef.current.has(uniqueId)) {
            console.log('[Room] Skipping duplicate transcription');
            return;
        }

        processedTranscriptionsRef.current.add(uniqueId);

        const transcription = {
            id: uniqueId,
            userId: msg.userId,
            userName: msg.user_name || participants.find(p => p.id === msg.userId)?.name || 'Unknown',
            transcript: msg.transcript,
            translation: msg.translation,
            confidence: msg.confidence || 1.0,
            language: msg.language || settings.sourceLang,
            timestamp: msg.timestamp || new Date().toISOString(),
            mock: msg.mock || false,
            isMine: msg.userId === userId,
        };

        console.log('[Room] Adding transcription:', transcription);

        setTranscriptions((prev) => [...prev, transcription]);

        if (addTranscriptionToStore) {
            addTranscriptionToStore(transcription);
        }

        if (processedTranscriptionsRef.current.size > 100) {
            const entries = Array.from(processedTranscriptionsRef.current);
            processedTranscriptionsRef.current = new Set(entries.slice(-100));
        }

    }, [settings.sourceLang, participants, userId, setTranscriptions, addTranscriptionToStore]);

    return {handleTranscription};
};
